// Display names for chart points.
export const PLANET_LABEL = {
  sun: "the Sun", moon: "the Moon", mercury: "Mercury", venus: "Venus", mars: "Mars",
  jupiter: "Jupiter", saturn: "Saturn", uranus: "Uranus", neptune: "Neptune", pluto: "Pluto",
  northNode: "the North Node", asc: "the Ascendant", mc: "the Midheaven",
};
export const PLANET_NAME = {
  sun: "Sun", moon: "Moon", mercury: "Mercury", venus: "Venus", mars: "Mars",
  jupiter: "Jupiter", saturn: "Saturn", uranus: "Uranus", neptune: "Neptune", pluto: "Pluto",
  northNode: "North Node", asc: "Ascendant", mc: "Midheaven",
};
export const ordinal = (n) => {
  const v = n % 100;
  if (v >= 11 && v <= 13) return `${n}th`;
  return `${n}${({ 1: "st", 2: "nd", 3: "rd" })[n % 10] || "th"}`;
};

/** Transit wording shared by Today and the first-run reveal: "Venus squares your Sun". */
export const TRANSIT_TARGET = { sun: "your Sun", moon: "your Moon", mercury: "your Mercury", venus: "your Venus", mars: "your Mars", jupiter: "your Jupiter", saturn: "your Saturn", uranus: "your Uranus", neptune: "your Neptune", pluto: "your Pluto", asc: "your Rising point", mc: "your Midheaven" };
export const TRANSIT_VERB = { conjunction: "meets", opposition: "opposes", square: "squares", trine: "flows with", sextile: "opens a door for" };
